module.exports = __webpack_public_path__ + "img/Wheels.9c017f6d.png";